module.exports = __webpack_public_path__ + "adobe-catalog.faec2728057db07ae80b14c976af2acd.png";